import React, { createContext, useReducer } from "react";

let initialState = {
  selectedOrgs: [],
  selectedTechs: [],
  selectedDemos: [],
  selectedStates: [],
  selectedOwnership: [],
}

const actions = {
  SET_ORG: "SET_ORG",
  SET_TECH: "SET_TECH",
  SET_DEMO: "SET_DEMO",
  SET_STATE: "SET_STATE",
  SET_OWNERSHIP: "SET_OWNERSHIP",
};

function reducer(state, action) {
  switch (action.type) {
    case actions.SET_ORG:
      return { ...state, selectedOrgs: action.value };
    case actions.SET_TECH:
      return { ...state, selectedTechs: action.value };
    case actions.SET_DEMO:
      return { ...state, selectedDemos: action.value };
    case actions.SET_STATE:
      return { ...state, selectedStates: action.value };
    case actions.SET_OWNERSHIP:
        return { ...state, selectedOwnership: action.value };            
    default:
      return state;
  }
}

const FilterContext = createContext();

const Provider = ({children}) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const value = {
    selectedOrgs: state.selectedOrgs,
    selectedTechs: state.selectedTechs,
    selectedDemos: state.selectedDemos,
    selectedStates: state.selectedStates,
    selectedOwnership: state.selectedOwnership,
    setOrg: value => {
      dispatch({ type: actions.SET_ORG, value });
    },
    setTech: value => {
      dispatch({ type: actions.SET_TECH, value });
    },
    setDemo: value => {
      dispatch({ type: actions.SET_DEMO, value });
    },
    setState: value => {
      dispatch({ type: actions.SET_STATE, value });
    },
    setOwnership: value => {
      dispatch({ type: actions.SET_OWNERSHIP, value });
    }
  }

  return (
    <FilterContext.Provider value={value}>
      {children}
    </FilterContext.Provider>
  )
};


export { Provider, FilterContext };